/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spoiler_OffInputs */

const th_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังแสดงคะแนนสด`)
};

const en_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Showing live scores`)
};

const ja_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブスコア表示中`)
};

const zh_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在显示实时比分`)
};

const es_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrando resultados en directo`)
};

const pt_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrando placares ao vivo`)
};

const id_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor langsung ditampilkan`)
};

const fr_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scores en direct affichés`)
};

const tl_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ipinapakita ang mga live na iskor`)
};

const vi_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang hiển thị tỉ số trực tiếp`)
};

const ko_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실시간 점수를 표시합니다`)
};

const de_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Ergebnisse werden angezeigt`)
};

const ru_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показываем счёт в прямом эфире`)
};

const tr_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı skorlar gösteriliyor`)
};

const it_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I punteggi in diretta sono visibili`)
};

const pl_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyniki na żywo są pokazywane`)
};

const uk_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рахунок у прямому ефірі показано`)
};

const hi_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव स्कोर दिखाए जा रहे हैं`)
};

const ar_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تُعرض النتائج المباشرة`)
};

const ms_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mata langsung dipaparkan`)
};

const bn_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সরাসরি স্কোর দেখানো হচ্ছে`)
};

const zh_tw2_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在顯示即時比分`)
};

const zh_hk2_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在顯示即時比分`)
};

const ur_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`براہ راست اسکور دکھائے جا رہے ہیں`)
};

const fa_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نتایج زنده نشان داده می‌شود`)
};

const sw_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matokeo ya moja kwa moja yanaonyeshwa`)
};

const nl_spoiler_off = /** @type {(inputs: Spoiler_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live standen worden getoond`)
};

/**
* | output |
* | --- |
* | "Showing live scores" |
*
* @param {Spoiler_OffInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const spoiler_off = /** @type {((inputs?: Spoiler_OffInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spoiler_OffInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_spoiler_off(inputs)
	if (locale === "ja") return ja_spoiler_off(inputs)
	if (locale === "zh") return zh_spoiler_off(inputs)
	if (locale === "es") return es_spoiler_off(inputs)
	if (locale === "pt") return pt_spoiler_off(inputs)
	if (locale === "id") return id_spoiler_off(inputs)
	if (locale === "fr") return fr_spoiler_off(inputs)
	if (locale === "tl") return tl_spoiler_off(inputs)
	if (locale === "vi") return vi_spoiler_off(inputs)
	if (locale === "ko") return ko_spoiler_off(inputs)
	if (locale === "de") return de_spoiler_off(inputs)
	if (locale === "ru") return ru_spoiler_off(inputs)
	if (locale === "tr") return tr_spoiler_off(inputs)
	if (locale === "it") return it_spoiler_off(inputs)
	if (locale === "pl") return pl_spoiler_off(inputs)
	if (locale === "uk") return uk_spoiler_off(inputs)
	if (locale === "hi") return hi_spoiler_off(inputs)
	if (locale === "ar") return ar_spoiler_off(inputs)
	if (locale === "ms") return ms_spoiler_off(inputs)
	if (locale === "bn") return bn_spoiler_off(inputs)
	if (locale === "zh-TW") return zh_tw2_spoiler_off(inputs)
	if (locale === "zh-HK") return zh_hk2_spoiler_off(inputs)
	if (locale === "ur") return ur_spoiler_off(inputs)
	if (locale === "fa") return fa_spoiler_off(inputs)
	if (locale === "sw") return sw_spoiler_off(inputs)
	if (locale === "nl") return nl_spoiler_off(inputs)
	return en_spoiler_off(inputs)
});